<span class="icon-inline" v-tooltip.bottom="tooltipOptions">
  <ChessHandAndBrainSvg preserveAspectRatio="xMidYMid meet" :style="svgStyle" />
</span>
